import { Box, Typography } from '@mui/material'
import { BRANDING } from '~/config/branding'

export function Footer() {
  return (
    <Box component="footer" sx={{ py: 2, textAlign: 'center' }}>
      <Typography variant="caption" color="text.secondary">
        © {BRANDING.copyrightFrom} {BRANDING.productName} · {BRANDING.productTitle}
      </Typography>
    </Box>
  )
}
